import { usePreferences } from 'context/preferences/PreferencesContext'
import { ContactCompanyType } from 'models/contact_companies'
import { useLayoutEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { getCompanyUrlFromId } from 'utils/getUnifiedSearchCompanyUrl'
import { getIdWithPrefix } from 'utils/pathUtils'
import { NewUnmatchedCompanyPage } from '../new-company-pages/NewUnmatchedCompanyPage'

export function CompanyPage() {
  const params = useParams()
  const { preferences } = usePreferences()
  const [loaded, setLoaded] = useState(false)

  useLayoutEffect(() => {
    // based on prefix, redirect to the correct page
    const redirectUrl = getCompanyUrlFromId(
      params?.company_id ?? '',
      preferences
    )
    if (redirectUrl) {
      window.location.href = redirectUrl
      return
    }

    setLoaded(true)
  }, [params?.company_id, preferences])

  if (!loaded) return null

  const companyID = getIdWithPrefix(
    params.company_id as string,
    preferences?.company_type_prefix_map[ContactCompanyType.UserGenerated]
  ) as number

  return <NewUnmatchedCompanyPage companyID={companyID} />
}
